<template lang="pug">
  div.item
    figure
      <!--img(src="@/assets/dummy_set.png")-->
      img(:src="'./static/thumb/' + item.code + '.jpg'")
    dl.name
      dt {{ item.name }}
      dd {{ item.code }}
      dd
        div.prc(v-if="check(item.w)")
          span 横幅&nbsp;
          strong {{ item.w * 10 }}mm&nbsp;&nbsp;
        div.prc(v-if="check(item.h)")
          span 高さ&nbsp;
          strong {{ item.h * 10 }}mm&nbsp;&nbsp;
        div.prc(v-if="check(item.d)")
          span 奥行&nbsp;
          strong {{ item.d * 10 }}mm
    dl.qua
      dt 価格
      dd.price {{ addComma(item.price) }}円
      dt 数量
      dd {{ item.qua }}
      dt 合計
      dd.price {{ addComma(item.price * item.qua) }}円
</template>

<script>
export default{
  name: 'Item',
  components: {
  },
  data () {
    return {
    };
  },
  props: {
    item: Object
  },
  computed: {
  },
  methods: {
    check (n) {
      if (n !== '' && n !== undefined && n !== 0) {
        return true;
      } else {
        return false;
      }
    },
    addComma (str) {
      return String(str).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
  },
  created () {
  },
  mounted () {
  }
};
</script>

<style lang="stylus" scoped>
  .item
    display flex
    align-items center
    margin-bottom 5px
    figure
      margin-right 10px
      border 1px solid #dddddd
      line-height 0
      img
        width 100px
        pointer-events none
    .name
      margin-right 20px
      width 200px
      dt
        font-weight bold
        font-size 12px
      dd
        font-size 10px
        .prc
          display inline-block
    .qua
      display flex
      justify-content space-between
      font-size 12px
      dt
        font-weight bold
        margin-right 10px
      dd
        margin-right 30px
        &.price
          width 60px
          text-align right
</style>



// WEBPACK FOOTER //
// src/components/total/Item.vue